function getStyle(partnerData) {
    const reportStyleData = {
        pdfHeaderColor: [105, 105, 105],
        pdfHeaderTextColor: [256, 256, 256],
        pdfBodyColor: [256, 256, 256],
        pdfBodyTextColor: [30, 30, 30],
        pdfFooterColor: [210, 210, 210],
        pdfFooterTextColor: [30, 30, 30],
        imgHeight: 0,
        imgWidth: 0,
    }

    if(partnerData && partnerData.reports){
        reportStyleData.pdfHeaderColor = partnerData.reports.mainColor || [105, 105, 105]
        reportStyleData.pdfFooterColor = partnerData.reports.mainColor || [210, 210, 210]
        reportStyleData.pdfFooterTextColor = partnerData.reports.mainColor ? [256, 256, 256] : [30, 30, 30]
        reportStyleData.imgHeight = partnerData.reports.logoHeight || 0
        reportStyleData.imgWidth = partnerData.reports.logoWidth || 0
    }

    return reportStyleData
}

exports.getStyle = getStyle

exports.pdfHeaderColor = [105, 105, 105]
exports.pdfHeaderTextColor = [256, 256, 256]
exports.pdfBodyColor = [256, 256, 256]
exports.pdfBodyTextColor = [30, 30, 30]
exports.pdfFooterColor = [210, 210, 210]
exports.pdfFooterTextColor = [30, 30, 30]



